module.exports = __webpack_public_path__ + "static/media/fly0112.0b4adb9c.webp";